import ReactPaginate from 'react-paginate';
import GetIcon from '../utils/Icon';
const Pagination = ({ setCurrentPage, totalrecords, pageSize,currentPage=null }) => {

    const handlePageChange = (selectedPage) => {
        const page = selectedPage.selected + 1;
        setCurrentPage(page);
    };

    return (
        <>
            <ReactPaginate
                previousLabel={
                    <li
                        className="page-item"
                        style={{
                            textDecoration: "underline",
                            textDecorationColor: "#eff4f9",
                        }}
                    >
                        <GetIcon iconName="FaAnglesLeft" color="grey" size={13} />
                    </li>
                }
                nextLabel={
                    <li
                        className="page-item"
                        style={{
                            textDecoration: "underline",
                            textDecorationColor: "#eff4f9",
                        }}
                    >
                        <GetIcon iconName="FaAnglesRight" color="grey" size={13} />
                    </li>
                }
                containerClassName="pagination"
                breakClassName="page-item"
                // forcePage={currentPage - 1}
                activeClassName="active"
                pageClassName="page-item"
                forcePage={currentPage ? currentPage - 1 : ''} 
                breakLabel={"..."}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                pageCount={Math.ceil(totalrecords / pageSize)}
                onPageChange={handlePageChange}
            />
        </>
    )
}

export default Pagination